// Generated by purs version 0.15.15
import * as Fusion_Data_Measurement from "../Fusion.Data.Measurement/index.js";
var getMeasurementColor = function (ld) {
    return function (ct) {
        if (ld instanceof Fusion_Data_Measurement.Download) {
            return ct.primary500;
        };
        if (ld instanceof Fusion_Data_Measurement.Upload) {
            return ct.secondary400;
        };
        if (ld instanceof Fusion_Data_Measurement.Ping) {
            return ct.tertiary400;
        };
        throw new Error("Failed pattern match at Visonum.Cross.Theme (line 58, column 29 - line 61, column 37): " + [ ld.constructor.name ]);
    };
};
var getAxisFontColor = function (ct) {
    return ct.gray500;
};
export {
    getMeasurementColor,
    getAxisFontColor
};
